define('app',['require','backbone','marionette','polyglot','context/utils','context/context','views/layout/sidebar','views/layout/header','views/layout/footer'],function(require){

	var Backbone = require('backbone');
	require('marionette');

    var Polyglot = require('polyglot');

	var Utils = require('context/utils');
    var Context = require('context/context');

    var SidebarView = require('views/layout/sidebar');
    var HeaderView = require('views/layout/header');
    var FooterView = require('views/layout/footer');

	var App = new Backbone.Marionette.Application();
	window.App = App;

	// Initialize dynamic regions
	App.addRegions({
        sidebarRegion: '#sidebar',
        headerRegion: '#header',
        footerRegion: '#footer',
        contentRegion: '#content',
        modalRegion: '#modal-container',
        messageRegion: '#message-container'
	});

    // Will be called when the App is started
	App.addInitializer(function() {
        App.utils = new Utils();

        App.contentRegion.on("show", function(){
            App.utils.showContent();
        });

        // Start the app
        new Context(function(context) {
            App.context = context;

            App.polyglot = new Polyglot({
                phrases: App.context.constants.localeData
            });

            App.sidebarRegion.show(new SidebarView());
            App.headerRegion.show(new HeaderView());
            App.footerRegion.show(new FooterView());

            Backbone.history.start({pushState: true});
        });
	});

	return App;
});
